<template>
  <div id="app">
    <div v-if="!isMobile()" class="tablet-up">
      <screen-container v-if="isAuthenticating">
        <spinner
          title="Cargando"
          description="Espera un momento, por favor."
          titleClass="text-white"
          descriptionClass="text-white"
          :submitting="isAuthenticating"
        />
      </screen-container>
      <fade-transition :duration="300">
        <div v-if="!isAuthenticating">
          <div v-if="isAuth" id="sidemenu">
            <button
              class="sidemenu__btn"
              v-on:click="navOpen = !navOpen"
              v-bind:class="{ active: navOpen }"
            >
              <span class="top"></span><span class="mid"></span
              ><span class="bottom"></span>
            </button>
            <transition name="translateX">
              <nav v-show="navOpen">
                <div class="sidemenu__wrapper">
                  <ul class="sidemenu__list">
                    <li class="sidemenu__item">
                      <a @click="logout()">Cerrar sesión</a>
                    </li>
                    <li class="sidemenu__item">
                      <a
                        v-on:click="navOpen = !navOpen"
                        v-if="grade === 0"
                        href="/#/"
                        >Inicio</a
                      >
                    </li>
                    <li class="sidemenu__item">
                      <a
                        v-on:click="navOpen = !navOpen"
                        v-if="essentias.includes('Mission Pre-K')"
                        href="/#/preek"
                        >Pre-k</a
                      >
                    </li>
                    <li class="sidemenu__item">
                      <a
                        v-on:click="navOpen = !navOpen"
                        v-if="essentials.some(item => item.includes('Misión Preescolar')) || verifyAccessToAdmin()"
                        href="/#/preschool"
                        >Preescolar</a
                      >
                    </li>
                    <li class="sidemenu__item">
                      <a
                        v-on:click="navOpen = !navOpen"
                        v-if="grade === 0"
                        href="/#/"
                        >Primaria</a
                      >
                    </li>
                    <li class="sidemenu__item">
                      <a
                        v-on:click="navOpen = !navOpen"
                        v-if="grade === 0"
                        href="/#/essential"
                        >Essentials</a
                      >
                    </li>
                    <!-- <li class="sidemenu__item">
                      <a
                        v-on:click="navOpen = !navOpen"
                        v-if="grade !== 0"
                        :href="`/#/mission/${grade}/libro`"
                        >Libro</a
                      >
                    </li> -->
                    <!-- <li class="sidemenu__item">
                      <a
                        v-on:click="navOpen = !navOpen"
                        v-if="grade !== 0"
                        :href="`/#/mission/${grade}/actividad`"
                        >Actividades</a
                      >
                    </li> -->
                    <li class="sidemenu__item">
                      <a
                        v-on:click="navOpen = !navOpen"
                        v-if="grade !== 0"
                        :href="`/#/mission/${manageGrades}/recursos`"
                        >Recursos</a
                      >
                    </li>
                  </ul>
                </div>
                <img class="mision-logo" src="/img/misionLogo.png" />
                <div class="legals">
                  <span
                    >© 2024 Copyright Misión Primaria. Derechos Reservados</span
                  >
                  <a href="mailto:soporte@mision.education" target="blank">
                    <span>Soporte Tecnológico:</span> soporte@mision.education
                  </a>
                  <a
                    href="https://www.mision.education/privacidad.html"
                    target="blank"
                    >Políticas de privacidad</a
                  >
                  <div style="display: flex">
                    <a
                      href="https://www.facebook.com/MisionPrimaria"
                      target="blank"
                      ><i class="fab fa-facebook"></i>
                    </a>
                    <a
                      href="https://www.linkedin.com/company/mision-primaria"
                      target="blank"
                      ><i class="fab fa-linkedin"></i>
                    </a>
                    <a
                      href="https://www.instagram.com/mision.primaria/"
                      target="blank"
                      ><i class="fab fa-instagram"></i
                    ></a>
                  </div>
                </div>
              </nav>
            </transition>
          </div>
          <router-view />
        </div>
      </fade-transition>
    </div>
    <div class="tablet-down">
      <div class="phone"></div>
      <div class="message">Por favor gire su dispositivo!</div>
    </div>
    <div v-if="isMobile()" class="tablet-down">
      <div class="phone"></div>
      <div class="message">Por favor gire su dispositivo!</div>
    </div>
  </div>
</template>
<script>
import { FadeTransition } from "vue2-transitions";
import "@/assets/sass/loader.scss";
import Auth from "../src/services/Auth";
import MatificButton from './components/MatificButton.vue';
export default {
  name: "App",
  components: {
    FadeTransition,
    MatificButton
  },
  data() {
    return {
      navOpen: false,
      isAuth: false,
      isStudent: false,
      grade: 0,
      e: null,
      essentials: [],
      userRole: []
    };
  },
  async created() {
    // NProgress.done();
    await this.init();
  },
  methods: {
    logout() {
      Auth.logout();
      this.navOpen = false;
    },
    init() {
      this.e = localStorage.getItem("userGrade");
      this.grade = parseInt(this.e ? this.e : 0);
      if (this.grade !== 0) {
        this.isStudent = true;
      }
      this.essentias = localStorage.getItem('essentias') ? localStorage.getItem('essentias') : [];
    },
    redirectByEssentias() {
      const hasPreescolar = this.essentias.some(item => item.includes("Misión Preescolar"));
      const hasPreeK = this.essentias.some(item => item.includes("Mission Pre-K"));
      const hasPrimaria = this.essentias.some(item => item.includes("Misión Primaria"));
      const hasEssential = this.essentias.some(item => item.includes("Fit For English Essentials"));

      if (hasPreescolar && hasPreeK) {
        this.$router.push('/preek');
      } else if (hasPreescolar) {
        this.$router.push('/preschool');
      } else if (hasPreeK) {
        this.$router.push('/preek');
      } else if (hasPrimaria) {
        this.$router.push('/primaria');
      } else if (hasEssential) {
        this.$router.push('/essential');
      }
    },
    isMobile: function () {
      var check = false;
      (function (a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        )
          check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    },
    verifyAccessToAdmin() {
      if (this.userRole.length > 0) {
        return this.userRole[0].roleCode === "SUPER-ADMIN" ? true : false;
      }
      return false
    }
  },
  computed: {
    missionId() {
      return parseInt(this.$route.params.missionId);
    },
    isAuthenticating() {
      this.isAuth = this.$store.state.session.isAuthenticated;
      this.init();
      return this.$store.state.session.isAuthenticating;
    },
   
    
  },
};
</script>

<style lang="scss">
.tablet-up {
  display: none;
  // @media only screen and (min-device-width: 780px) and (orientation: landscape) and (min-device-height: 400px) {
  // @media (min-width: 768px) and (orientation: landscape) {
  //   display: block;
  // }
  @media (min-width: 500px) {
    display: block;
  }
}
.tablet-down {
  background-color: black;
  height: 100vh;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  @media (min-width: 500px) {
    display: none;
  }
}

// NPROGRESS
.phone {
  height: 50px;
  width: 100px;
  border: 3px solid white;
  border-radius: 10px;
  animation: rotate 1.5s ease-in-out infinite alternate;
  /* display: none; */
}

.message {
  color: white;
  font-size: 1em;
  margin-top: 40px;
  /* display: none; */
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(-90deg);
  }
  100% {
    transform: rotate(-90deg);
  }
}

@media only screen and (max-device-width: 812px) and (orientation: landscape) {
  .phone,
  .message {
    display: block;
  }
}
#nprogress .bar {
  background: #00afaa !important;
  height: 4px !important;
}

#nprogress .peg {
  box-shadow: 0 0 10px #00afaa, 0 0 5px #00afaa !important;
}

#nprogress .spinner-icon {
  border-top-color: #00afaa !important;
  border-left-color: #00afaa !important;
}

.btn-primary:disabled:hover {
  opacity: 0.65;
  cursor: not-allowed;
}
.login-form {
  border-radius: 50px;
  max-width: 60vw;
  min-height: 52vh;
  // padding-left: 6rem;
  // padding-top: 8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    max-width: 378px;
    min-width: 200px;
  }
}

#app .page-header:after,
.page-header:before {
  height: 0;
}
.login-container {
  // margin: 5.8em 0;
  justify-content: center;
  align-items: center;
  display: flex;
  min-height: 100vh;
  padding-top: 0rem;
  padding-bottom: 0rem;
  background-image: url(/img/new/containerLogin.png);
  background-size: contain;
  background-repeat: no-repeat;
  background-size: 100% auto;
  background-position: center;
}
@media (max-width: 1230px) {
  .login-container {
    background-image: url(/img/new/recurso2.png);
  }
}
.screen-container {
  background-image: url("/img/new/backgroundLoginDesk.png");
  background-attachment: fixed;
  background-size: cover;
}

.home {
  padding-top: 1rem;
  padding-bottom: 2rem;
  margin-top: 0rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cursor-progress {
  cursor: progress;
}

.cursor-pointer {
  cursor: pointer;
}

.mission-card {
  cursor: pointer;
}

.mission-card:hover {
  transform: scale(1.2);
}
// navbar
body #app #sidemenu {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 99999999999999999999 !important;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  .mision-logo {
    max-width: 400px;
    margin: auto;
    opacity: 0.1;
    position: absolute;
    top: calc(50vh - 60px);
    left: calc(50vw - 200px);
  }
  nav {
    width: 100vw;
    background: #20455ffa;
    border: 4px solid #6b94b1;
    height: 100vh;
    margin-top: -50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .legals {
    bottom: 0;
    position: absolute;
    width: calc(100vw - 26px);
    display: flex;
    color: #fff;
    align-items: center;
    justify-content: space-between;
    margin: 5px 10px;
    a {
      color: #fff;
      font-size: 16px;
      i {
        font-size: 23px;
        padding-left: 12px;
      }
    }
  }
  .sidemenu {
    &__btn {
      display: block;
      width: 50px;
      height: 50px;
      background: #6b94b1;
      border: none;
      position: relative;
      z-index: 100;
      appearance: none;
      cursor: pointer;
      outline: none;
      span {
        display: block;
        width: 20px;
        height: 2px;
        margin: auto;
        background: white;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        transition: all 0.4s ease;

        &.top {
          transform: translateY(-8px);
        }

        &.bottom {
          transform: translateY(8px);
        }
      }
      &.active {
        .top {
          transform: rotate(-45deg);
        }
        .mid {
          transform: translateX(-20px) rotate(360deg);
          opacity: 0;
        }
        .bottom {
          transform: rotate(45deg);
        }
      }
    }

    &__list {
      padding-top: 50px;
      list-style: none;
      padding: 0;
      margin: 0;
    }

    &__item {
      a {
        text-decoration: none;
        line-height: 1.6em;
        font-size: 3.6em;
        padding: 0.5em;
        display: block;
        color: white;
        font-family: "Montserrat";
        font-weight: 900;
        transition: all 0.9s ease-in;
        text-shadow: 2px 2px 2px #00000078;
        &:hover {
          background: #6b94b1;
          color: #fff;
          cursor: selector;
          cursor: pointer;
          transition: 3;
          transition: all 0.5s ease-out;
        }
      }
      &:last-child {
        a {
          border-bottom: none;
        }
      }
    }
  }
}

.translateX-enter {
  transform: translateX(-200px);
  opacity: 0;
}

.translateX-enter-active,
.translateX-leave-active {
  transform-origin: top left 0;
  transition: 0.2s ease;
}

.translateX-leave-to {
  transform: translateX(-200px);
  opacity: 0;
}
</style>
